var styles = {"fontElementMap":"vvs5i","orderedlist":"_7YmJ0","bulletedlist":"yp1cz","listItem":"uCdC-"};

export { styles as s };
//# sourceMappingURL=lists-32e4c371.js.map
